import { type MetricResultBlock } from '@myre/app-agent-domain/registry/result-block';
import { verbatim } from '@myre/common-i18n';
import { ModalService } from '@myre/ui-primitive-modal';

import { inject, Injectable } from '@angular/core';

import { ResultTableComponent } from '../components/result-table/result-table.component';

/**
 * The chat window pins itself above the app's notification layer
 * (chat-window.component.scss: z-index 10000001); the table modal must clear it
 * too or it opens underneath the chat.
 */
const ABOVE_CHAT_Z_INDEX = 10000002;

/** Opens the full result behind a card, at full width. */
@Injectable({ providedIn: 'root' })
export class ResultTableModalService {
  private readonly _modalService = inject(ModalService);

  public open(result: MetricResultBlock): void {
    this._modalService.openFactory(uid => ({
      key: 'result-table.full-screen',
      size: 'full',
      zIndex: ABOVE_CHAT_Z_INDEX,
      // The title is the entry's own label, already in the reader's language:
      // the client composes no heading for a registry it knows nothing about.
      header: { data: { title: verbatim(result.title) } },
      body: {
        component: ResultTableComponent,
        bindings: { inputs: { result } },
      },
      context: {
        closeClick: () => {
          this._modalService.close(uid);
        },
      },
    }));
  }
}
